import React from 'react'
import { makeStyles } from '@material-ui/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListSubheader from '@material-ui/core/ListSubheader'
import { Link as LinkTo } from 'react-router-dom'
import Link from '@material-ui/core/Link'
import { MdAddCircleOutline } from 'react-icons/md'
import IconButton from '@material-ui/core/IconButton'

import { menuData } from './menuData'
import usePath from 'hooks/usePath'
import styles from './contentMenu.module.scss'

const useStyles = makeStyles(theme => ({
  header: { lineHeight: 'normal', color: theme.palette.secondary.main },
}))

const SubComponent = props => {
  const path = usePath()
  return (
    <ListItem
      button
      selected={
        path[1] === props.component.id || path[2] === props.component.id
      }
    >
      <Link
        component={LinkTo}
        to={`/dashboard/${props.component.id}`}
        className={styles.links}
        // style={{
        //   display: 'flex',
        //   alignItems: 'center',
        //   color: 'lightgrey',
        //   flexGrow: '1',
        //   '&:hover': {
        //     textDecoration: 'none !important',
        //   },
        // }}
      >
        <div className={styles.icon}>{props.component.icon}</div>
        <h3 className={styles.text}>{props.component.label}</h3>
      </Link>
      <Link component={LinkTo} to={`/dashboard/new/${props.component.id}`}>
        <IconButton
          color={
            path[1] === 'new' && path[2] === props.component.id
              ? 'primary'
              : 'default'
          }
        >
          {props.component.createNew && <MdAddCircleOutline />}
        </IconButton>
      </Link>
    </ListItem>
  )
}

const ContentMenu = props => {
  const classes = useStyles()

  return (
    <div className={styles.contentMenu}>
      <List component="nav" aria-label="main mailbox folders">
        {menuData.map((components, index) => {
          return (
            <div key={components.id} className={styles.section}>
              <ListSubheader
                component="div"
                id="nested-list-subheader"
                className={classes.header}
                style={{ backgroundColor: '#00000000' }}
              >
                {components.label}
              </ListSubheader>
              {components.items.map((component, index) => (
                <SubComponent
                  key={component.id}
                  component={component}
                  index={index}
                />
              ))}
            </div>
          )
        })}
      </List>
    </div>
  )
}

export default ContentMenu
